// src/hooks/ScrollToHash.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHash = () => {
  const location = useLocation();

  useEffect(() => {
    const scrollToElement = () => {
      if (location.hash) {
        const id = location.hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    };

    const handleLoad = () => {
      // Espera un pequeño tiempo por si hay componentes que aún se montan
      setTimeout(scrollToElement, 100);
    };

    // Si la página ya está cargada
    if (document.readyState === "complete") {
      handleLoad();
    } else {
      window.addEventListener("load", handleLoad);
      // Limpia el listener cuando el componente se desmonta
      return () => window.removeEventListener("load", handleLoad);
    }
  }, [location]);

  return null;
};

export default ScrollToHash;
